import { Icon } from "@iconify/react";

interface IconsProps {
    icon: string;
    className?: string;
    width?: string;
    rotate?: number;
    hFlip?: boolean;
    vFlip?: boolean;
    color?: string;
}

const Icons = ({
    icon,
    className,
    width,
    rotate,
    hFlip,
    vFlip,
    color,
}: IconsProps) => {
    return (
        <>
            <Icon
                width={width}
                rotate={rotate}
                hFlip={hFlip}
                icon={icon}
                className={className}
                vFlip={vFlip}
                color={color}
            />
        </>
    );
};

export default Icons;
